/**
 * Styled Components - Created by cazarez on 14/03/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  margin-top: var(--spacing-24) !important;
  div.content-review {
    position: unset !important;
  }
  div.yotpo-clr {
    clear: left !important;
  }
  .yotpo-head {
    display: none !important;
  }
  .yotpo-base-layout {
    width: 100% !important;
  }
  .yotpo-bottom-line-score {
    font: 700 40px / 42px var(--font-barlow-semi-condensed) !important;
  }
  .yotpo-bottom-line-basic-text {
    font: 400 12px / 20px var(--font-inter) !important;
    color: #737370 !important;
  }
  .yotpo-star-distribution-index {
    color: var(--neutral-body) !important;
    text-align: right !important;
    font: 400 12px / 19.2px var(--font-inter) !important;
  }
  .yotpo-star-distribution-index-wrapper .yotpo-star-rating-icon {
    width: 12px !important;
    height: 12px !important;
    transform: none !important;
  }
  .yotpo-star-distribution-value {
    color: var(--neutral-secondary) !important;
    text-align: right !important;
    font: 400 12px / 19.2px var(--font-inter) !important;
  }
  #yotpo-main-widget-btn {
    border-radius: 0 !important;
    background: var(--neutral-darkest) !important;
    text-transform: uppercase !important;
    font: 600 12px / 18px var(--font-barlow) !important;
    letter-spacing: 1px !important;
  }
  .yotpo-reviewer-name-text {
    color: var(--neutral-darkest) !important;
    font: 600 14px / 22px var(--font-inter) !important;
  }
  .yotpo-reviewer-flag,
  .yotpo-verified-icon-wrapper {
    display: none !important;
  }
  .yotpo-reviewer-verified-buyer-text {
    color: var(--neutral-secondary) !important;
    font: 400 12px / 20px var(--font-inter) !important;
    &::before {
      content: '✓' !important;
      display: inline-block !important;
      width: 16px !important;
    }
  }
  .yotpo-verified-image-icon {
    width: 40px !important;
    height: 40px !important;
  }
  .yotpo-review-rating-title {
    flex-direction: column !important;
    margin-bottom: 2px !important;
  }
  .yotpo-review-rating-title .yotpo-review-title {
    margin-left: 0 !important;
    margin-top: var(--spacing-8) !important;
    color: var(--neutral-darkest) !important;
    font: 600 20px / 26px var(--font-barlow-semi-condensed) !important;
    letter-spacing: 0.6px !important;
  }
  .star-container {
    width: 14px !important;
    height: 14px !important;
  }
  .yotpo-paragraph-summary-text, 
  .yotpo-read-more-text {
    color: var(--neutral-body) !important;
    font: 400 14px / 22px var(--font-inter) !important;
  }
  .yotpo-review-left-panel > .yotpo-reviewer {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  .yotpo-date-format {
    color: var(--neutral-secondary) !important;
    text-align: right !important;
    font: 400 12px / 20px var(--font-inter) !important;
  }
  .yotpo-review-right-panel {
    padding-left: 0 !important;
  }
  .yotpo-review-votes-text {
    color: var(--neutral-secondary) !important;
    text-align: right !important;
    font-size: 0 !important;
    &::before {
      content: 'Helpful?' !important;
      font: 400 12px / 20px var(--font-inter) !important;
    }
  }
  .yotpo-paragraph-summary-title, 
  .yotpo-reviews-summary-button-text {
    font-family: var(--font-barlow) !important;
  }
  .yotpo-new-review-btn.yotpo-btn-l.empty-state,
  .yotpo-reviews-pagination-item.yotpo-vertical-pagination-item, 
  .yotpo-reviews-summary-button.yotpo-reviews-summary-button--style-1 {
    box-sizing: border-box !important;
    display: inline-flex !important;
    height: var(--spacing-42) !important;
    padding: var(--spacing-8) var(--spacing-16) !important;
    justify-content: center !important;
    align-items: center !important;
    gap: var(--spacing-8) !important;
    background: var(--neutral-white) !important;
    border: var(--border-regular) solid var(--neutral-muted) !important;
    border-radius: 0 !important;
    color: var(--neutral-body) !important;
    font: 600 12px / 18px var(--font-barlow) !important;
    letter-spacing: 1px !important;
    text-transform: uppercase !important;
    white-space: nowrap !important;
    transition: border .25s, color .25s !important;
    &:hover {
      cursor: pointer !important;
      color: var(--neutral-darkest) !important;
      border-color: var(--neutral-darkest) !important;
    }
  }
  .yotpo-new-review-btn.yotpo-new-review-btn.yotpo-btn-l.empty-state {
    width: auto !important;
    min-width: max-content !important;
    max-width: none !important;
    padding-inline: var(--spacing-24) !important;
    color: var(--neutral-white) !important;
    &:hover {
      color: var(--neutral-white) !important;
    }
  }
  @media (max-width: 1024px) {
    padding-inline: 18px;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/YotpoReviews/styledComponents.tsx